import React from "react";
import { CalendarDays } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/i18n/LanguageContext";
import { SectionLayout } from "@/components/SectionLayout";

export const Itinerary = ({ data }) => {
  const { L, t } = useLang();
  const { content } = useContent();
  const days = Array.isArray(data) ? data : [];
  const notice = content?.itineraryNotice;
  const tips = content?.worshipTips;

  const WorshipTips = ({ city, titleCity }) => {
    const list = tips?.[city] || [];
    if (!list.length) return null;
    return (
      <details className="maqam-card mt-4 overflow-hidden rounded-3xl p-0" data-testid={`worship-${city}`}>
        <summary className="cursor-pointer list-none px-5 py-4 font-display text-base font-bold text-[#0A192F]">
          {t("worship.title")} — {titleCity}
        </summary>
        <ul className="space-y-2 px-5 pb-5">
          {list.map((it, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm text-[#0A1128]/75">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#D4AF37]" />
              {L(it)}
            </li>
          ))}
        </ul>
      </details>
    );
  };

  return (
    <SectionLayout id="itinerary" icon={CalendarDays}>
      {notice && (
        <div className="mb-6 rounded-2xl border border-[#D4AF37]/30 bg-[#FBF3D8]/60 px-4 py-3 text-sm leading-relaxed text-[#0A1128]/80" data-testid="itinerary-notice">
          {L(notice)}
        </div>
      )}

      <div className="relative pl-8">
        <div className="absolute left-[9px] top-2 bottom-2 w-0.5 bg-[#D4AF37]/30" />
        <div className="space-y-6">
          {days.map((d) => (
            <div key={d.id} className="relative" data-testid={`itinerary-${d.id}`}>
              <span className="absolute -left-8 top-1.5 grid h-5 w-5 place-items-center rounded-full border-2 border-[#D4AF37] bg-[#F8FAFC]">
                <span className="h-2 w-2 rounded-full bg-[#D4AF37]" />
              </span>
              <div className="maqam-card rounded-3xl p-5">
                <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] font-semibold">{L(d.day)}</p>
                <h3 className="mt-0.5 font-display text-xl font-medium text-[#0A192F]">{L(d.title)}</h3>
                {d.note && (
                  <p className="mt-2 rounded-xl bg-[#EAF2FC] px-3.5 py-3 text-sm leading-relaxed text-[#3E6B9A]">{L(d.note)}</p>
                )}
                <ul className="mt-3 space-y-2">
                  {(d.items || []).map((item, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm font-light text-[#0A1128]/75">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#0A192F]/40" />
                      {L(item)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <WorshipTips city="madinah" titleCity={t("prayer.madinah")} />
      <WorshipTips city="makkah" titleCity={t("prayer.makkah")} />
    </SectionLayout>
  );
};
